<waitLoading *ngIf="!isLoaded()"></waitLoading>
<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="false"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '50vh'}" styleClass="custombar1">
  <div cdkTrapFocus [cdkTrapFocusAutoCapture]="true" class="container-fluid m-b-lg pb-5">
    <!--h2 class="modal-title">
      <i class="fas fa-search" aria-hidden="true"></i>
      {{ 'SearchGeneric.finder' | translate }} CPVs
    </h2-->
    <!-- FILTRO DEL BUSCADOR -->
    <div class="row m-t-md m-b-lg">
      <div class="col-12 m-b-md">
        <div class="border-bottom border-top">
          <p-tree [value]="treeModel" selectionMode="single" [(selection)]="selectedObject"
            (onNodeSelect)="accept($event)" autofocus *ngIf="isLoaded()">
            <ng-template let-node let-rowIndex="rowIndex" pTemplate="default">
              <span tabindex="rowIndex" (keyup.enter)="accept($event)">{{ node.data.name }}</span>
            </ng-template>
          </p-tree>
        </div>
      </div>
    </div>
  </div>
</p-scrollPanel>